
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/updates",
      function () {
        return require("private-next-pages/updates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/updates"])
      });
    }
  